module.exports = __webpack_public_path__ + "static/media/protect.eea5ac85.png";